import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
    selector: 'app-single-vehicle',
    templateUrl: './single.html'
})

export class SingleVehicleViewComponet {

    public breadcrumbData = {
        "Information": "/organization/transport-manager/information",
        "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
    };

    vendorID: string;
    vehicelData: any;
    orgID: any;
    vehicleID: any;
    imageFile: any;
    fileName: string;
    public isVehActive:any='Active';
    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public storage: StorageService,
        public api: ApiService,
        public file: FileUploadService,
        public comService:CommonServices

    ) {
        this.route.paramMap.subscribe((params: any) => {
            this.vendorID = params.params.vendorID;
            this.vehicleID = params.params.vehicleID;

            let vendorName = this.storage.get('vendorID_orgID')['vendorName'];
            if(vendorName){
              vendorName = this.comService.strTruncate(vendorName,13);
              this.breadcrumbData[vendorName] =  "/organization/transport-manager/information/vendor/single-view-vendor/"+this.vendorID;
            }else{
              this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/"+this.vendorID;
            }
            this.breadcrumbData['Vehicles'] = "/organization/transport-manager/information/vehicle/view-vehicle/" + this.vendorID;
            this.breadcrumbData['View'] = '';

        });
        this.orgID = this.storage.get('userInfo').orgID;
        this.vehicelData = this.storage.get('vehicleData');
    }

    ngOnInit() {
        this.getVehicleData();
    }
    getVehicleData() {
        const obj = {
            orgID: this.orgID,
            vendorID: this.vendorID,
            vehicleID: this.vehicleID
        };
        this.api.transportManagerVehicleList(obj).then((res: any) => {
            if (res.status == 'success') {
                this.vehicelData = res.data[0];
                if(this.vehicelData.isActive==true){
                    this.isVehActive='Active';
                }else{
                    this.isVehActive='Inactive';
                }
                this.fileName = `${this.vehicelData['vehRegNo'].toUpperCase()}_RcBook.jpg`;
                this.convertURLintoImg(this.vehicelData.rcfile);
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    async convertURLintoImg(url) {
        // console.log(url);
        this.imageFile = await this.file.urlHandleBase64(url);
        // console.log(this.imageFile);
    }

    downloadRcBook() {
        // console.log(this.imageFile);
        document.getElementById('downloadRc').click();
    }
}
